import { Component, inject, input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

import { SharedModule } from "@app/modules/shared/shared.module";
import { ExceedsLimitPipe } from "@app/shared/pipes/exceeds-limit.pipe";
import { CustomValidators } from "@app/shared/validators/custom-validators";

@Component({
  selector: "app-zerez-section",
  imports: [TranslateModule, SharedModule, ExceedsLimitPipe],
  templateUrl: "./zerez-section.component.html",
})
export class ZerezSectionComponent implements OnInit {
  certificateLabel = input.required<string>();
  certificateName = input.required<string>();
  documentForm = input.required<FormGroup>();
  isCertificateMandatory = input(false);
  zerezIdsFormArray!: FormArray<FormControl<string>>;

  readonly #formBuilder = inject(FormBuilder);

  ngOnInit(): void {
    this.zerezIdsFormArray = this.documentForm().get(
      this.certificateName(),
    ) as FormArray;
  }

  public addZerezId(): void {
    const control = this.#formBuilder.control<string>("", {
      updateOn: "blur",
      validators: [CustomValidators.trimValidator, CustomValidators.shortText],
    }) as FormControl<string>;

    this.zerezIdsFormArray.push(control);
  }

  public deleteZerezId(index: number): void {
    this.zerezIdsFormArray.removeAt(index);
  }
}
